export default "__VITE_ASSET__B4gamAC0__"